module.exports = __webpack_public_path__ + "static/media/logo.501ed78f.png";